// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  cueId: __t.u64().primaryKey().name("cue_id"),
  target: __t.identity(),
  kind: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  refId: __t.u64().name("ref_id"),
  variant: __t.u8(),
  createdAt: __t.timestamp().name("created_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
